import { render, staticRenderFns } from "./MainResource.vue?vue&type=template&id=7cc9e07e&scoped=true"
import script from "./MainResource.vue?vue&type=script&lang=js"
export * from "./MainResource.vue?vue&type=script&lang=js"
import style0 from "./MainResource.vue?vue&type=style&index=0&id=7cc9e07e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cc9e07e",
  null
  
)

export default component.exports